<template>
  <!-- Layout Footer -->
  <a-layout-footer>
    <a-row type="flex">
      <a-col :span="24" :md="12">
        <p class="copyright">
          © {{ currentYear }} MechTrace.
        </p>
      </a-col>
      <a-col :span="24" :md="12" class="footer-control">
        <!-- Footer Navigation Menu -->
        <a-menu mode="horizontal">
          <a-menu-item key="about">
            <a href="#" @click.prevent>About Us</a>
          </a-menu-item>
          <a-menu-item key="blog">
            <a href="#" @click.prevent>Blog</a>
          </a-menu-item>
          <a-menu-item key="license">
            <a href="#" @click.prevent>License</a>
          </a-menu-item>
        </a-menu>
        <!-- / Footer Navigation Menu -->
      </a-col>
    </a-row>
  </a-layout-footer>
  <!-- / Layout Footer -->
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'DashboardFooter',
  setup() {
    const currentYear = computed(() => {
      return new Date().getFullYear()
    })

    return {
      currentYear
    }
  }
}
</script>

<style scoped>
.ant-layout-footer {
  background: #fafafa;
  padding: 24px 50px;
}

.copyright {
  margin: 0;
  color: #8c8c8c;
  font-size: 14px;
}

.footer-control {
  display: flex;
  justify-content: flex-end;
}

.footer-control .ant-menu {
  background: transparent;
  border: none;
}

.footer-control .ant-menu-item {
  border: none !important;
}

.footer-control .ant-menu-item a {
  color: #8c8c8c;
}

.footer-control .ant-menu-item a:hover {
  color: #1890ff;
}

@media (max-width: 768px) {
  .footer-control {
    justify-content: center;
    margin-top: 16px;
  }
  
  .copyright {
    text-align: center;
  }
}
</style>